import { Container, Row } from "reactstrap";
import AddRows from "./AddRows";
import ChildRows from "./childRows";
import CustomFiltering from "./CustomFiltering";
import RowSelectionAndDeletion from "./RowSelectionAndDeletion";
import { APIDataTablesTitle, DataTitle } from "../../../../../constants";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const APIContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={APIDataTablesTitle} parent={DataTitle} />
      <Container fluid>
        <Row>
          <AddRows />
          <ChildRows />
          <RowSelectionAndDeletion />
          <CustomFiltering />
        </Row>
      </Container>
    </>
  );
};
export default APIContainer;
